import { render, staticRenderFns } from "./UserPhone.vue?vue&type=template&id=e2d29d7e"
import script from "./UserPhone.vue?vue&type=script&lang=js"
export * from "./UserPhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports